<template>
  <div>
    <div>
      <!-- <el-row style="margin: 10px 0px 30px 0px;"> -->
      <!-- <el-col :span="3">
          <el-button icon="el-icon-check" class="hiaButton" plain round size="mini" @click="runAcknowledgeNoChanges()">Acknowledge No Changes</el-button>
        </el-col> -->
      <!-- <el-col :span="21">
          &nbsp;
          <center class="stats">
            <el-badge v-for="stat in proListStatistics" :key="stat.key" class="item" :class="{ 'stats-loading': statsLoading }" :value="stat.count">
              <el-tag type="primary" size="small">{{ stat.key }}</el-tag>
            </el-badge>
          </center>
        </el-col>
        <el-col :span="3">
          <el-row :gutter="2">
            <el-col :span="24">
              <el-input id="globalSearch" type="text" size="mini" placeholder="filter all..." v-model="filterCriteria" v-on:keyup.native="runGlobalFilter($event)"> </el-input>
            </el-col>
          </el-row>
        </el-col> -->
      <!-- </el-row> -->
      <el-row>
        <div style="margin-top: 10px; min-height: 200px;">
          <portal to="destinationPRO">
            <el-select id="rfcFilter" v-loading="tableLoader" element-loading-spinner="none" key="rfcMulti" v-model="reasonForChangeMultiSelect" placeholder="" :clearable="false" multiple :collapse-tags="true" @visible-change="handleRFCMultiSelect($event)" @remove-tag="handleRFCMultiSelect()">
              <el-option v-for="item in proListMeta.reasonForChangeList" :key="item" :label="item" :value="item"> </el-option>
            </el-select>
          </portal>
          <portal to="responseRequiredLastPRO">
            <el-select id="rsFilter" v-loading="tableLoader" element-loading-spinner="none" key="rsMulti" v-model="responseRequiredMultiSelect" placeholder="" :clearable="false" multiple :collapse-tags="true" @visible-change="handleRSMultiSelect($event)" @remove-tag="handleRSMultiSelect()">
              <el-option v-for="item in proListMeta.responseRequiredList" :key="item" :label="item" :value="item"> </el-option>
            </el-select>
          </portal>

          <v-server-table ref="coderProListGrid" id="coderProListGrid" :columns="columns" :options="options" class="hiaTable" @loading="tableLoader = true" @loaded="tableLoader = false" v-loading="tableLoader" element-loading-spinner="nucleus-loader">
            <template slot="filter__reasonForChangeDesc">
              <portal-target name="destinationPRO"> </portal-target>
            </template>
            <template slot="filter__responseRequiredLast">
              <portal-target name="responseRequiredLastPRO"> </portal-target>
            </template>
            <template slot="patientNumber" slot-scope="props">
              <router-link :to="`/${currentClientId}/my-projects/pro/${props.row.proRecordId}`">{{ props.row.patientNumber }}</router-link>
            </template>
            <template slot="dateofService" slot-scope="props">
              <div>
                {{ props.row.dateofService ? formatDate(props.row.dateofService) : '' }}
              </div>
            </template>
            <template slot="particleUrl" slot-scope="props">
              <div>
                <a :href="`${compParticleBaseUrl}/reviews/pro/${props.row.proRecordId}`" target="_new">{{ props.row.patientNumber }}</a>
              </div>
            </template>
            <template slot="completeDate" slot-scope="props">
              <div>
                {{ props.row.completeDate ? formatDate(props.row.completeDate) : '' }}
              </div>
            </template>
            <template slot="reviewDate" slot-scope="props">
              <div>
                {{ props.row.reviewDate ? formatDate(props.row.reviewDate) : '' }}
              </div>
            </template>
            <template slot="level2ReasonForChange" slot-scope="props">
              <div>
                {{ props.row.reviewLevel !== 'Coding Review' ? props.row.level2ReasonForChange : '' }}
              </div>
            </template>
            <template slot="rebuttalDate" slot-scope="props">
              <div>
                {{ props.row.rebuttalDate ? formatDate(props.row.rebuttalDate) : '' }}
              </div>
            </template>
            <template slot="rebuttalDateLast" slot-scope="props">
              <div>
                {{ props.row.rebuttalDateLast ? formatDate(props.row.rebuttalDateLast) : '' }}
              </div>
            </template>
            <template slot="displayClientName" slot-scope="props">
              <div class="displayClientNameText" :title="props.row.displayClientName">
                {{ props.row.displayClientName }}
              </div>
            </template>
            <template slot="agreeWithCodesLast" slot-scope="props">
              <div style="display: flex; align-items: center;">
                <i v-if="props.row.agreeWithCodesLast" :style="`font-size: 18px;margin-right: 5px;color:${props.row.agreeWithCodesLast === 'Yes' ? `#67c23a` : `#e6a23c;`}`" :class="props.row.agreeWithCodesLast === 'Yes' ? `el-icon-circle-check` : `el-icon-warning-outline`"></i><span>{{ props.row.agreeWithCodesLast }}</span>
              </div>
            </template>
            <template slot="rebuttals" slot-scope="props">
              <div style="display: flex; align-items: center;">
                <i v-if="props.row.rebuttals.length" :style="`cursor: pointer;width: 100%; text-align: center; font-size: 18px;color:${props.row.responseRequiredLast === 'Completed' ? `#67c23a` : `#e6a23c;`}`" :class="props.row.responseRequiredLast === 'Completed' ? `el-icon-chat-line-round` : `el-icon-chat-dot-round`" @click="handleRebuttalDisplayModal(props.row)"></i>
              </div>
            </template>
          </v-server-table>
        </div>
      </el-row>
    </div>
    <div id="dialogs">
      <coderInpatientWorksheetModal v-if="showWorksheetModal" :proRecordId="worksheetproRecordId" :showWorksheetModal="showWorksheetModal" @close="handleModalClose"> </coderInpatientWorksheetModal>
      <rebuttalDisplay :record="selectedRecord" :rebuttalDisplayModal="rebuttalDisplayModal" @close="rebuttalDisplayModal = false"></rebuttalDisplay>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

import dateHelper from '@/mixins/date-helper'
import hiaTable from '@/mixins/hiaTable'
import debounce from 'debounce'
import HiaAuthorization from '@/mixins/hiaAuthorization'
import rebuttalDisplay from '@/views/MyProjects/rebuttalDisplay'

export default {
  name: 'inpatientList',
  mixins: [dateHelper, hiaTable, HiaAuthorization],
  data() {
    return {
      showMassUpdateDialog: false,
      statsLoading: false,
      vueTables2Query: {},
      loading: true,
      showWorksheetModal: false,
      worksheetproRecordId: null,
      filterCriteria: '',
      tableLoader: false,
      isActivated: true,
      reasonForChangeMultiSelect: [],
      reasonForChangeMultiSelectBackup: [],
      responseRequiredMultiSelect: [],
      responseRequiredMultiSelectBackup: [],
      columns: ['patientNumber', 'particleUrl', 'displayClientName', 'physicianName', 'numberDxCodes', 'numberEMCodes', 'numberCPTCodes', 'numberFindings', 'mrnumber', 'consultantNumber', 'payorName', 'coder', 'reasonForChangeDesc', 'dateofService', 'placeOfService', 'providerType', 'practiceName', 'patientName', 'reviewDate', 'agreeWithCodesLast', 'rebuttals', 'responseRequiredLast'],
      options: {
        // see the options API
        actionsPosition: 'right',
        requestFunction: data => {
          return this.requestData(data)
        },
        debounce: 600,
        filterByColumn: true,
        listColumns: {
          reviewLevel: []
        },
        filterable: ['patientNumber', 'particleUrl', 'displayClientName', 'physicianName', 'numberDxCodes', 'numberEMCodes', 'numberCPTCodes', 'numberFindings', 'mrnumber', 'consultantNumber', 'payorName', 'coder', 'dateofService', 'placeOfService', 'providerType', 'practiceName', 'patientName', 'reviewDate', 'agreeWithCodesLast', 'rebuttals'],
        orderBy: {
          // column: 'patientNumber',
          // ascending: true
        },
        columnsClasses: {
          selected: 'selected',
          // excludeRecord: 'hideColumn',
          // ipreviewType: 'hideColumn',
          // subClientNumber: 'hideColumn',
          // originalReviewer: 'hideColumn',
          // originalReviewDate: 'hideColumn',
          // originalClientNumber: 'hideColumn',
          // reviewLevel: 'hideColumn',
          reasonForChangeDesc: 'reasonForChangeDesc',
          responseRequiredLast: 'responseRequiredLast',
          particleUrl: 'hide',
          delete: 'delete',
          displayClientName: 'displayClientName'
        },
        headings: {
          selected: h => {
            return h('input', {
              attrs: {
                type: 'checkbox',
                id: 'selectAllCheckboxProList'
              },
              on: {
                click: e => {
                  this.selectAll(e.srcElement.checked)
                }
              },
              ref: 'selectAllCheckbox'
            })
          },
          agreeWithCodes: 'Agree with Changes',
          patientNumber: 'Patient Number',
          consultantNumber: 'Consultant Number',
          payorName: 'Payor',
          mrnumber: 'MR Number',
          patientName: 'Patient Name',
          practiceName: 'Practice Name',
          providerType: 'Provider Type',
          physicianName: 'Provider',
          dateofService: 'Date of Service',
          reasonForChangeDesc: 'Reason F Change',
          numberFindings: '# Findings',
          numberEMCodes: '# EM Codes',
          numberCPTCodes: '# CPT Codes',
          numberDxCodes: '# Dx Codes',
          placeOfService: 'Place of Service',
          status: 'Review Status',
          reviewDate: 'Review Date',
          finalOutcome: 'Final Outcome',
          auditResult: 'Audit Result',
          responseNeeded: 'Response Needed',
          responseCount: 'Response Count',
          rebuttalDate: 'Response Date',
          agreeWithCodesLast: 'Agree With Findings',
          agreeWithGroupingLast: 'Agree With Grouping',
          responseRequiredLast: 'Response Status',
          rebuttalDateLast: 'Response Date',
          codesStatusLast: 'Codes Outcome',
          groupingStatusLast: 'Grouping Outcome',
          particleUrl: 'Particle URL',
          displayClientName: 'Facility',
          rebuttals: 'View Rebuttals'
        },
        perPage: 25,
        texts: {
          filter: '',
          filterBy: '...'
        },
        highlightMatches: true,
        sortIcon: { is: 'none' }
      },
      selectedRecord: [],
      rebuttalDisplayModal: false
    }
  },
  methods: {
    ...mapActions('myProjects/', ['LOAD_REBUTTALS_PRO_LIST_PAGINATED', 'RUN_PRO_MASS_ACKNOWLEDGE_NO_CHANGES']),
    ...mapActions('dropdowns/', ['GET_DROPDOWNS', 'CONVERT_DROPDOWN_COLUMNFILTERARRAY']),
    ...mapMutations('inpatientReviews/', ['SET_PROLIST_SELECTED', 'CLEAR_PROLIST_SELECTED', 'SET_PROLIST_REFRESH_FUNC']),
    async requestData(data) {
      try {
        data.projectID = this.$route.params.id
        data.query.projectID = this.$route.params.id
        data.globalSearch = this.filterCriteria
        data.query.reasonForChangeMultiSelect = this.reasonForChangeMultiSelect
        data.query.responseRequiredMultiSelect = this.responseRequiredMultiSelect
        this.vueTables2Query = data
        this.statsLoading = true
        const resultArray = await this.LOAD_REBUTTALS_PRO_LIST_PAGINATED(data)
        this.options.columnsClasses.particleUrl = this.documentManagerAdmin() ? '' : 'hide'
        this.statsLoading = false
        return resultArray
      } catch (err) {
        console.log(err)
      }
    },
    getSelectedRecords() {
      const simpleArray = this.proListSelected.map(y => y.proRecordId)
      return [...new Set(simpleArray)]
    },
    async localSelectAll(checked) {
      const table = this.$refs.ipReviewListGrid.$el
      const checkboxes = table.querySelectorAll('input[type ="checkbox"]')

      if (checked) {
        this.tableLoader = true
        await this.GET_PRO_LIST_ALLIDS(this.vueTables2Query)
        for (let i = 0; i < checkboxes.length; i++) {
          checkboxes[i].checked = true
        }
        this.tableLoader = false
        // this.$refs.ipReviewListGrid.refresh()
      } else {
        this.CLEAR_PROLIST_SELECTED()
        for (let i = 0; i < checkboxes.length; i++) {
          checkboxes[i].checked = false
        }
        // this.$refs.ipReviewListGrid.refresh()
      }
    },
    runGlobalFilter: debounce(function() {
      this.$refs.coderProListGrid.getData()
    }, 400),
    async handleMassUpdate(massUpdateModel) {
      this.showMassUpdateDialog = false
      // this.localSelectAll(false) // clear all the selected checkboxes
      // this.$refs.ipReviewListGrid.getData()
    },
    runAcknowledgeNoChanges() {
      this.$confirm('Acknowledge No Changes for records without changes?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        const payload = {
          projectID: this.$route.params.id,
          rebuttalDate: new Date().toISOString()
        }
        this.tableLoader = true
        this.RUN_PRO_MASS_ACKNOWLEDGE_NO_CHANGES(payload).then(
          () => {
            this.$refs.coderProListGrid.getData()
            this.tableLoader = false
            this.$message({
              message: 'Acknowledge No Changes Successful',
              type: 'success'
            })
          },
          error => {
            console.log(error)
            this.tableLoader = false
            const message = error.response.data.message || 'Acknowledge No Changes Error'
            this.$message({
              message: message,
              type: 'error'
            })
          }
        )
      })
    },
    handleRFCMultiSelect(isOpenEvent) {
      if (isOpenEvent === true) {
        this.reasonForChangeMultiSelectBackup = JSON.parse(JSON.stringify(this.reasonForChangeMultiSelect))
        return
      }

      if (JSON.stringify(this.reasonForChangeMultiSelectBackup) !== JSON.stringify(this.reasonForChangeMultiSelect)) {
        this.$refs.coderProListGrid.getData()
        this.reasonForChangeMultiSelectBackup = JSON.parse(JSON.stringify(this.reasonForChangeMultiSelect))
      }
    },
    handleRSMultiSelect(isOpenEvent) {
      if (isOpenEvent === true) {
        this.responseRequiredMultiSelectBackup = JSON.parse(JSON.stringify(this.responseRequiredMultiSelect))
        return
      }

      if (JSON.stringify(this.responseRequiredMultiSelectBackup) !== JSON.stringify(this.responseRequiredMultiSelect)) {
        this.$refs.coderProListGrid.getData()
        this.responseRequiredMultiSelectBackup = JSON.parse(JSON.stringify(this.responseRequiredMultiSelect))
      }
    },
    handleRebuttalDisplayModal(row) {
      this.selectedRecord = row
      this.rebuttalDisplayModal = true
    }
  },
  computed: {
    ...mapState('user/', ['currentClient', 'currentClientName', 'currentClientId', 'clients', 'user']),
    ...mapState('proReviews/', ['statistics', 'proListSelected', 'proListRecordValidations']),
    ...mapState('projects/', ['projectPK', 'project']),
    ...mapState('dropdowns/', ['dropdowns']),
    ...mapState('myProjects/', ['proListStatistics', 'proListMeta']),
    compParticleBaseUrl() {
      return process.env.VUE_APP_PARTICLE_BASE_URL
    }
  },
  created: function() {
    // this.defaultColumns = JSON.parse(JSON.stringify(this.sortableColumns))
    // this.loading = true
  },
  mounted: function() {
    if (this.$route.query.id) {
      this.openWorksheetModal({ proRecordId: this.$route.query.id })
    }
  },
  activated: function() {
    if (this.$refs.coderProListGrid && !this.isActivated) {
      this.$refs.coderProListGrid.getData()
    }
    this.isActivated = true
  },
  deactivated: function() {
    this.isActivated = false
    this.localInpatientReviews = []
    // clear any old validation messages, validation messages can be left around because the form validation gets triggered natively by
    // the browser when users hit the enter key in the form
    if (this.$refs.addForm) {
      this.$refs.addForm.clearValidate()
    }
    // this.localSelectAll(false)
    // this.CLEAR_PROLIST_SELECTED()
  },
  components: {
    rebuttalDisplay
  }
}
</script>

<style scoped>
.item {
  margin-top: 3px;
  margin-right: 35px;
}

.stats-loading {
  opacity: 0.5;
}

.stats .el-tag {
  background-color: transparent !important;
  color: #909399 !important;
  border-color: #e9e9eb !important;
}

.stats >>> .el-badge__content {
  background-color: #f4f4f5 !important;
  color: #303133 !important;
}

>>> .reasonForChangeDesc,
>>> .responseRequiredLast {
  min-width: 145px;
}

>>> .reasonForChangeDesc .el-tag,
>>> .responseRequiredLast .el-tag {
  max-width: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
}

>>> .rfcFilter {
}

>>> .hide {
  display: none !important;
}

>>> .displayClientName {
  max-width: 100px;
}

>>> .displayClientNameText {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
